import React from 'react';
import PropTypes from 'prop-types';
import { getSectionColor, getSectionAbbr } from 'utils/Formatters';

const ASQSectionResults = ({ survey }) => {
  if (!survey.sections) return null;
  return (
    survey.sections.map(section => {
      const name = survey.type === 'asq_3' ? getSectionAbbr(section.name) : section.score.result;
      return (name &&
        <span key={section.name} className={`cs-txt--sp-${getSectionColor(section.score.result)}`}>
          {name}
        </span>
      );
    })
  );
}

ASQSectionResults.propTypes = {
  survey: PropTypes.object.isRequired,
}

export default ASQSectionResults;
